import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Modal from 'react-responsive-modal';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import {InputText} from 'primereact/inputtext';
import noimage from '../../Comman/images/no_image.png';
import loader from '../../Comman/images/loader.gif'
import {baseUrl} from '../../Comman/apiEndPoints'
import swal from 'sweetalert';
import { withNamespaces } from 'react-i18next';
import SimpleReactValidator from 'simple-react-validator';
var OptionsCounterDet=0;
var EmojiCounterDet=0;
var rowData;
var svValidator;
var engValidator;
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
const url=baseUrl;
const popover = {
      position: 'absolute',
      zIndex: '2',
    }
    const cover = {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    }
class TetraResourcesComponent extends Component {
    toastId = null;
    constructor(props) {
        super(props); 
        this.state = {
            open: false,
          
        };
       
      
      
         
    }
 
    componentWillMount() { 
        SimpleReactValidator.addLocale('en', {
            required : 'The :attribute field is required.',
            min : 'The :attribute must be at least :min:type.'
        });
        SimpleReactValidator.addLocale('sv', {
            required : 'Fältet :attribute krävs.',
            min : ':attribute måste vara minst :min tecken.'
        });
        engValidator = new SimpleReactValidator(
            {
                locale : 'en'
            }
          ); 
          svValidator = new SimpleReactValidator(
            {
                locale : 'sv'
            }
          ); 
          this.validator = engValidator;
      }
    componentWillReceiveProps(nextProps) { 
       /*  if (nextProps.feedbackSettings !== this.props.feedbackSettings) {
             if(nextProps.statusCode==200){
                    this.notify(nextProps.feedbackSettings.messageLabel)
                     this.closeModal();
                     this.setState(this.baseState);
                     this.props.getFeedbackQuesList();
            }
            if(nextProps.statusCode==201){
                this.errornotify(nextProps.feedbackSettings.messageLabel)
            }
        } */
        this.translateLang();
    }
    translateLang(){
        var language;
        if(sessionStorage.getItem('Language')){
          language = sessionStorage.getItem('Language');
        }
        else{
          language = "en";
        }
        if(language == "en"){
          this.validator = engValidator;
        }
        else{
          this.validator = svValidator;
        }
      }
  

    errornotify = (message) => {
        swal({text : message, icon : 'error'}) 
        // this.toastId =toast.error(message, {
        //   position: toast.POSITION.TOP_CENTER
        // }); 
      }

   
  closeModal() {
        this.setState({ open: false })
     
    }
 
     notify = (message) => { 
        swal({text : message, icon : 'success'})
    //   this.toastId =toast.success(message, {
    //     position: toast.POSITION.TOP_CENTER
    //   }); 
      this.closeModal(); 
    }
    
    // isMandatoryColumn(rowDatas) { 
    //     var Value="";
    //     if(rowDatas.Mandatory == false)
    //      Value="false";
    //     else
    //     Value="true"
    //     return (
    //         <span>
    //            {Value   }
    //         </span>
    //     ) 
    // }
    // isHiddenColumn(rowDatas) { 
    //     var Value="";
    //     if(rowDatas.QuestionHidden == false)
    //      Value="false";
    //     else
    //     Value="true"
    //     return (
    //         <span>
    //            {Value   }
    //         </span>
    //     ) 
    // }
       caseStatus(rowData) {
    if (rowData.StatusName) {
        
            
            return (<p style={{backgroundColor: rowData.StatusColor}}>{rowData.StatusName}</p>) 
        }
    }


 rowExpansionTemplate = (data) => {
       
        const { t } = this.props;
        return (
            <div className="orders-subtable">
                <DataTable 
                    className="table"
                    value={data.CaseDetails}
                    paginator={true} rows={10}
                    rowClassName={this.rowClassName}
                    responsiveLayout="scroll" 
                    emptyMessage={t('Feedback Setting.No records found')}
                >
                    <Column field="CaseNumber" header="Case Number" sortable={true} />
                    <Column field="StatusName" header="Status" body={this.caseStatus} sortable={true} />
                  
                    <Column field="CaseUpdatedDate" body={this.UpdatedCaseUpdatedDate} header='Case Created Time' />
                </DataTable>
            </div>
        );
    }
    UpdatedCaseUpdatedDate(rowData) {
        if (rowData.CreatedDate != null && rowData.CreatedDate != undefined) {
            if (rowData.StatusUpdated == "0001-01-01T00:00:00") {
                return;
            }
            else {
                let value = rowData.CreatedDate.split('T');
                let data = value[1].split(':');
                 let sec=data[2].split('.')
                return (<p>{value[0] + " " + data[0] + ":" + data[1] + ":" + sec[0]}</p>)
            }
        }
    }
statusUpdateTime(rowData) {
        if (rowData.StatusUpdated != null && rowData.StatusUpdated != undefined) {
            if (rowData.StatusUpdated == "0001-01-01T00:00:00") {
                return;
            }
            else {
                let value = rowData.StatusUpdated.split('T');
                let data = value[1].split(':');
                 let sec=data[2].split('.')
                return (<p>{value[0] + " " + data[0] + ":" + data[1] + ":" + sec[0]}</p>)
            }
        }
    }
     postUpdateTime(rowData) {
        if (rowData.PosUpdated != null && rowData.PosUpdated != undefined) {
            if (rowData.UpdatedDate == "0001-01-01T00:00:00") {
                return;
            }
            else {
                let value = rowData.PosUpdated.split('T');
                let data = value[1].split(':');
                 let sec=data[2].split('.')
                return (<p>{value[0] + " " + data[0] + ":" + data[1] + ":" + sec[0]}</p>)
            }
        }
    }
     render() {
           const { t } = this.props;
           var header = <div className="search-name">
               <i className="fa fa-search" style={{ margin: '4px 4px 0 0' }}></i>
               <InputText type="text" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder={t('First_Responder.Search')} size="50" />
           </div>;
           return (
               <div>
                   <div className="progressbar-heading grids-heading">
                       <h2>Tetra Resources List</h2>
                   </div>
                   <div className=" forms-panel w3-last-form">
                       <div className="forms add-device">
                           <div className="form-three widget-shadow">
                               <div className=" panel-body-inputin">
   
                                   <div className="w3l_search">
                                       {header}
                                   </div>
                                   <div className="devicestable">
                                       <br />
   
                                       <DataTable
                                           className="table"
                                           value={this.props.getTetraResources.tetraResourceList}
                                           loading={this.props.getTetraResources.isLoading}
                                           paginator={true} rows={10}
                                           globalFilter={this.state.globalFilter}
                                           emptyMessage={t('Feedback Setting.No records found')}
                                           rowExpansionTemplate={this.rowExpansionTemplate}
                                           onRowToggle={(e) => this.setState({ expandedRows: e.data })}
                                           expandedRows={this.state.expandedRows}
                                       >
                                           <Column expander style={{ width: '3em' }} />
                                           {/* <Column field="UserId" header="" className="noDisplay" sortable={true} />
                                           <Column field="DeviceId" header="" className="noDisplay" sortable={true} /> */}
   
                                           <Column field="EntityShortName" header="Entity Number" sortable={true} />
                                           <Column field="EntityFullName" header="Entity Name" sortable={true} />
                                           <Column field="ResourceStatus" header="Resource Status" sortable={true} />
                                              <Column sortable={true}  body={this.statusUpdateTime} header="Resources Updated Time"  />
                                           <Column field="ResourceStatusShortCode" header="Resource Code" sortable={true} />
                                           <Column field="PosLat" header="Latitute" sortable={true} />
                                           <Column field="PosLon" header="Longitute" sortable={true} />
                                           <Column sortable={true}  body={this.postUpdateTime} header="Position Updated Time"  />
                                           <Column field="MSISDN" header="MSISDN" sortable={true} />
                                           <Column field="TermAddress" header="TermAddress" sortable={true} />
   
                                       </DataTable>
                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>
           )
       }
}

export default withNamespaces()(withRouter(TetraResourcesComponent));